<template>
  <!-- container -->
  <div id="middleWrapM" class="container">
    <!-- sub title -->
    <div class="sub_tit_area invest04">
      <img :src="`${resources}img/img-top-sub-title9.jpg`" alt="" />
      <div class="tit_area">
        <div class="sub_tit">공고</div>
        <div class="sub_txt">주요 경영사항을 공고합니다.</div>
      </div>
    </div>
    <!--// sub title -->

    <!-- sub contents -->
    <div class="sub_contents">
      <div class="flex_box">
        <h3>공고</h3>
        <div class="selectbox3 ty_wid">
          <!-- 스크립트 필요 부분 - 셀렉트 선택 시 active class추가 부탁드립니다.-->
          <select id="select" v-model="year">
            <option v-for="val in this.options" :key="val.id">{{ val }}</option>
          </select>
          <i class="ico_select"></i>
        </div>
      </div>
      <div class="tbl_scroll_area tbl_min">
        <div class="tbl_ty01 bod">
          <table>
            <caption>
              공시:구분,등록일,관련자료로 구성
            </caption>
            <colgroup>
              <col style="width: auto" />
              <col style="width: 20%" />
              <col style="width: 20%" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">구분</th>
                <th scope="col">등록일</th>
                <th scope="col">관련자료</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in listItems" :key="`inverst-tr-${idx}`">
                <td class="aLeft">
                  {{ item.title }}
                </td>
                <td class="aCenter">{{ item.reg_date }}</td>
                <td class="aCenter">
                  <a
                    class="btn_line"
                    :title="item.file_oriname"
                    href="#"
                    @click.prevent="download(item.seq)"
                    >내용보기</a
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="btn_cnt_wrap">
        <button
          type="button"
          class="btn_morelist"
          v-if="curPageIdx + 1 !== this.viewPageLength"
          @click.prevent="changePage(showPageLabel(curPageIdx + 1) - 1)"
        >
          더보기
        </button>
      </div>
    </div>
    <!--// sub contents -->
  </div>
  <!--// container -->
</template>
<script>
import invest021 from '@/pages/invest/p_invest021';

export default invest021;
</script>

<style lang="scss" scoped></style>
